var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imgPreviewOpened
    ? _c(
        "div",
        {
          staticClass:
            "modal fade show wf-inspiration-overlay inspiration-page-gallery-overlay"
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog inspiration-full-modal h-100",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content h-100" }, [
                _c("div", { staticClass: "modal-body h-100" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "wf-inspiration-overlay-button-close btn button-full",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.setImgPreviewOpened(false)
                          _vm.setIsImageInfoOpened(false)
                          _vm.$helpers.enableScrolling()
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-symbols--k-txtclose",
                        attrs: { "aria-label": "Close inspiration overlay" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row h-100" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-sm-3 col-lg-3 h-100" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "wf-inspiration-info-collapse inspiration-page-gallery-info-block collapse-gallery show h-100",
                            class: _vm.isMobile ? "w-100" : ""
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "wf-inspiration-info inspiration-page-gallery-info"
                              },
                              [
                                _c("div", { staticClass: "pdp-heart-icon" }, [
                                  _c("span", {
                                    staticClass:
                                      "png-icon png-icon-icons-glyph--k-heart cursor-pointer float-right",
                                    on: {
                                      click: function($event) {
                                        return _vm.addToProject(
                                          _vm.openedImage.mainProduct
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "\n                      secondary-heading\n                      info-secondary-heading\n                      d-block mr-5 mt-0\n                      text-dark text-decoration-none\n                    ",
                                      attrs: {
                                        href: _vm.$helpers.getCollectionOverviewUrl(
                                          _vm.openedImage.mainProduct
                                            .collectionCode
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.openedImage.mainProduct
                                              .collectionName
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "path-header" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "inspiration.images.gallery.in.this.design"
                                        ]
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "path-block d-flex flex-wrap"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "path d-block text-dark text-decoration-none cart-item-model-no",
                                        attrs: {
                                          href: _vm.$helpers.getProductDetailUrl(
                                            _vm.openedImage.mainProduct
                                              .styleNameURL,
                                            _vm.openedImage.mainProduct
                                              .sellingStyleNumber,
                                            _vm.openedImage.mainProduct
                                              .mainColor.colorNumber
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.openedImage.mainProduct
                                                .sellingStyleName
                                            ) +
                                            "\n                    " +
                                            _vm._s(
                                              _vm.openedImage.mainProduct
                                                .sellingStyleNumber
                                            )
                                        ),
                                        _c("Icon", {
                                          staticClass:
                                            "gallery-info-right-arrow-icon",
                                          attrs: {
                                            icon: "dashicons:arrow-right-alt"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "path d-block text-dark text-decoration-none",
                                        attrs: {
                                          href:
                                            "/tags/?name=" +
                                            _vm.openedImage.mainProduct
                                              .productType
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.openedImage.mainProduct
                                                .productType
                                            )
                                        ),
                                        _c("Icon", {
                                          staticClass:
                                            "gallery-info-right-arrow-icon",
                                          attrs: {
                                            icon: "dashicons:arrow-right-alt"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "path d-block text-dark text-decoration-none",
                                        attrs: {
                                          href:
                                            "/tags/?name=" +
                                            _vm.openedImage.mainProduct
                                              .productType +
                                            "+" +
                                            _vm.openedImage.mainProduct
                                              .productCategory
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.openedImage.mainProduct
                                                .productCategory
                                            )
                                        ),
                                        _c("Icon", {
                                          staticClass:
                                            "gallery-info-right-arrow-icon",
                                          attrs: {
                                            icon: "dashicons:arrow-right-alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "color-image-block" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.$helpers.getColorThumbnailImageUrl(
                                          _vm.openedImage.mainProduct
                                            .sellingStyleNumber,
                                          _vm.openedImage.mainProduct.mainColor
                                            .colorNumber
                                        ),
                                        alt:
                                          _vm.openedImage.mainProduct
                                            .sellingStyleName +
                                          "+ " +
                                          _vm.openedImage.mainProduct.mainColor
                                            .colorNumber
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-block text-dark text-decoration-none cart-item-model-no",
                                        attrs: {
                                          href: _vm.$helpers.getProductDetailUrl(
                                            _vm.openedImage.mainProduct
                                              .styleNameURL,
                                            _vm.openedImage.mainProduct
                                              .sellingStyleNumber,
                                            _vm.openedImage.mainProduct
                                              .mainColor.colorNumber
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.openedImage.mainProduct
                                                .mainColor.colorName
                                            ) +
                                            "\n                    " +
                                            _vm._s(
                                              _vm.openedImage.mainProduct
                                                .mainColor.colorNumber
                                            )
                                        ),
                                        _c("Icon", {
                                          staticClass:
                                            "gallery-info-right-arrow-icon",
                                          attrs: {
                                            icon: "dashicons:arrow-right-alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "see-more-arrow-up w-0"
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "see-more-block d-flex text-dark text-decoration-none cart-item-model-no",
                                    attrs: {
                                      href: _vm.$helpers.getProductDetailUrl(
                                        _vm.openedImage.mainProduct
                                          .styleNameURL,
                                        _vm.openedImage.mainProduct
                                          .sellingStyleNumber,
                                        _vm.openedImage.mainProduct.mainColor
                                          .colorNumber
                                      )
                                    }
                                  },
                                  [
                                    _c("wf-load-image", {
                                      attrs: {
                                        "wrapper-class": "see-more-image-block",
                                        "image-class": "",
                                        src: _vm.$helpers.getColorThumbnailImageUrl(
                                          _vm.openedImage.mainProduct
                                            .sellingStyleNumber,
                                          _vm.openedImage.mainProduct.mainColor
                                            .colorNumber
                                        ),
                                        alt:
                                          _vm.openedImage.mainProduct
                                            .sellingStyleName +
                                          "+ " +
                                          _vm.openedImage.mainProduct.mainColor
                                            .sellingStyleNumber +
                                          " "
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "see-more-text m-auto" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "inspiration.images.gallery.see.more"
                                              ]
                                            ) +
                                            "\n                    "
                                        ),
                                        _c("Icon", {
                                          staticClass:
                                            "gallery-info-right-arrow-icon",
                                          attrs: {
                                            icon: "dashicons:arrow-right-alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.openedImage.mainProduct.lookBook
                                  ? _c(
                                      "div",
                                      { staticClass: "look-book-block" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "look-book-file-name"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.openedImage.mainProduct
                                                    .lookBookTitle
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "\n                      call-to-action-button\n                      btn btn-white\n                      border-dark\n                      look-book-button\n                    ",
                                            attrs: {
                                              href:
                                                _vm.openedImage.mainProduct
                                                  .lookBook
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "\n                        png-icon\n                        png-icon-icons-glyph--k-btn-download\n                        look-book-icon\n                      "
                                            }),
                                            _vm._v(" "),
                                            _c("p", { staticClass: "m-auto" }, [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$resourceString[
                                                      "inspiration.images.gallery.look.book"
                                                    ]
                                                  ) +
                                                  "\n                    "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: !_vm.openedImage.mainProduct.lookBook
                                      ? "mt-2"
                                      : ""
                                  },
                                  [
                                    _c("wf-add-to-cart-button-only", {
                                      attrs: {
                                        "selling-style-number":
                                          _vm.openedImage.mainProduct
                                            .sellingStyleNumber,
                                        "color-number":
                                          _vm.openedImage.mainProduct.mainColor
                                            .colorNumber,
                                        quantity: 1,
                                        "save-for-later": false,
                                        "inventory-style-number":
                                          _vm.openedImage.mainProduct
                                            .sellingStyleNumber,
                                        "is-button": true,
                                        "is-disabled":
                                          _vm.openedImage.mainProduct.mainColor
                                            .isSampleAvailable == true
                                            ? false
                                            : true
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.openedImage.products.length > 0
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "other-products" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "inspiration.images.gallery.other.presented.products"
                                                ]
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "list-unstyled" },
                                        _vm._l(
                                          _vm.openedImage.products,
                                          function(product) {
                                            return _c(
                                              "li",
                                              {
                                                key: product.sellingStyleNumber,
                                                staticClass: "d-flex flex-wrap"
                                              },
                                              _vm._l(product.colors, function(
                                                color
                                              ) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: color.colorNumber,
                                                    staticClass:
                                                      "\n                          other-products-link\n                          w-100\n                          d-block\n                          text-dark text-decoration-none cart-item-model-no\n                        ",
                                                    attrs: {
                                                      href: _vm.$helpers.getProductDetailUrl(
                                                        product.styleNameURL,
                                                        product.sellingStyleNumber,
                                                        color.colorNumber
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          product.sellingStyleNumber +
                                                            " in color "
                                                        ) +
                                                        "\n                        " +
                                                        _vm._s(
                                                          color.colorNumber
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "product-detail-desc mt-3" },
                                  [
                                    _vm.openedImage.mainProduct.projectName
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$resourceString[
                                                    "inspiration.images.gallery.projectname"
                                                  ]
                                                ) +
                                                "\n                      :\n                    "
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.openedImage.mainProduct
                                                  .projectName
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.openedImage.mainProduct.city
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$resourceString[
                                                    "inspiration.images.gallery.city"
                                                  ]
                                                ) +
                                                "\n                      :\n                    "
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.openedImage.mainProduct.city
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.openedImage.mainProduct.state
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$resourceString[
                                                    "inspiration.images.gallery.state"
                                                  ]
                                                ) +
                                                "\n                      :\n                    "
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.openedImage.mainProduct
                                                  .state
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.openedImage.mainProduct.designFirm
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$resourceString[
                                                    "inspiration.images.gallery.designfirm"
                                                  ]
                                                ) +
                                                "\n                      :\n                    "
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.openedImage.mainProduct
                                                  .designFirm
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.openedImage.mainProduct.photographer
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$resourceString[
                                                    "inspiration.images.gallery.photographer"
                                                  ]
                                                ) +
                                                "\n                      :\n                    "
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.openedImage.mainProduct
                                                  .photographer
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-8 col-sm-9 col-lg-9 h-100" },
                      [
                        !_vm.isMyproject
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "inspiration-prev-image-button btn button-full",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.changePreviewImage(-1)
                                  }
                                }
                              },
                              [
                                _c("Icon", {
                                  attrs: {
                                    icon: "ep:arrow-right",
                                    color: "white",
                                    rotate: 2,
                                    height: "30"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("wf-load-image", {
                          attrs: {
                            "wrapper-class": "main-preview-image w-100 h-100",
                            "image-class": "w-100 h-100",
                            src: _vm.$helpers.getWidenImgURL(
                              _vm.openedImage.embedId,
                              2000
                            ),
                            alt: _vm.openedImage.imageAltText || ""
                          }
                        }),
                        _vm._v(" "),
                        !_vm.isMyproject
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "inspiration-next-image-button btn button-full",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.changePreviewImage(1)
                                  }
                                }
                              },
                              [
                                _c("Icon", {
                                  attrs: {
                                    icon: "ep:arrow-right",
                                    color: "white",
                                    height: "30"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              staticClass: "my-project-modal",
              attrs: {
                height: "650",
                name: "project-wizard-product-content-modal",
                "data-html2canvas-ignore": "true",
                adaptive: true,
                scrollable: true
              }
            },
            [
              _c("pc-project-wizard-content-modal", {
                on: {
                  closeModal: function($event) {
                    return _vm.closeModal($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }